/* eslint-disable react-refresh/only-export-components */
import { useState, useEffect } from 'react';
import styles from './Toast.module.css';

export type ToastType = 'success' | 'error' | 'info';

interface ToastItem {
  id: string;
  type: ToastType;
  message: string;
}

const TOAST_EVENT = 'ops-console-toast';

export const toast = {
  success(message: string) {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { type: 'success', message } }));
  },
  error(message: string) {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { type: 'error', message } }));
  },
  info(message: string) {
    window.dispatchEvent(new CustomEvent(TOAST_EVENT, { detail: { type: 'info', message } }));
  },
};

export function ToastContainer() {
  const [toasts, setToasts] = useState<ToastItem[]>([]);

  useEffect(() => {
    const handleToast = (e: Event) => {
      const { type, message } = (e as CustomEvent<{ type: ToastType; message: string }>).detail;
      const id = Math.random().toString(36).substring(2, 9);
      setToasts((prev) => [...prev, { id, type, message }]);

      // Auto-remove after 4 seconds
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, 4000);
    };

    window.addEventListener(TOAST_EVENT, handleToast);
    return () => window.removeEventListener(TOAST_EVENT, handleToast);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className={styles.container}>
      {toasts.map((t) => (
        <div key={t.id} className={`${styles.toast} ${styles[t.type]}`}>
          <span className={styles.message}>{t.message}</span>
          <button
            className={styles.close}
            onClick={() => setToasts((prev) => prev.filter((item) => item.id !== t.id))}
          >
            &times;
          </button>
        </div>
      ))}
    </div>
  );
}
